import { Pagination, Table } from "antd";
import PlayersLineChart from "../../PlayersLineChart/PlayersLineChart";

import "./stylesFraudulentOptionsTable.css";
import { useState } from "react";

function FraudulentOptionsTable() {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const handlePaginationChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const data = [
    {
      date: "Oct 05, 2024 12:34 PM",
      action: "Deposit",
      details: "$ 4,500.00",
      fraudNote: "Made a withdrawal after deposit",
      ip: "192.168.0.1",
    },
    {
      date: "Oct 11, 2024 11:34 PM",
      action: "Withdrawal",
      details: "$ 2,500.00",
      fraudNote: "Made a deposit after withdrawal",
      ip: "192.168.0.1",
    },
    {
      date: "Oct 15, 2024 12:34 PM",
      action: "Login to the system",
      details: "$ 2,500.00",
      fraudNote: "Suspicious login from a new device",
      ip: "192.168.0.1",
    },
    {
      date: "Oct 05, 2024 12:34 PM",
      action: "Deposit",
      details: "$ 4,500.00",
      fraudNote: "Made a withdrawal after deposit",
      ip: "192.168.0.1",
    },
    {
      date: "Oct 11, 2024 11:34 PM",
      action: "Withdrawal",
      details: "$ 2,500.00",
      fraudNote: "Made a deposit after withdrawal",
      ip: "192.168.0.1",
    },
    {
      date: "Oct 15, 2024 12:34 PM",
      action: "Login to the system",
      details: "$ 2,500.00",
      fraudNote: "Suspicious login from a new device",
      ip: "192.168.0.1",
    },
  ];

  const columns = [
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      sorter: (a, b) => new Date(a.date) - new Date(b.date),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      sorter: (a, b) => a.action.localeCompare(b.action),
    },
    {
      title: "Details",
      dataIndex: "details",
      key: "details",
      sorter: (a, b) => a.details.localeCompare(b.details),
    },
    {
      title: "Fraud Note",
      dataIndex: "fraudNote",
      key: "fraudNote",
      sorter: (a, b) => a.fraudNote.localeCompare(b.fraudNote),
    },
    {
      title: "IP Address",
      dataIndex: "ip",
      key: "ip",
      sorter: (a, b) => a.ip.localeCompare(b.ip),
    },
  ];

  const kpis = {
    labels: [
      "Aug 20",
      "Sep 20",
      "Oct 20",
      "Nov 20",
      "Dec 20",
      "Jan 21",
      "Feb 21",
      "Mar 21",
    ],
    datasets: [
      {
        label: "Balance",
        data: [20000, 25000, 30000, 40000, 32000, 31000, 28000, 24000],
        borderColor: "#FD6F27",
        backgroundColor: "#FD6F27",
        borderRadius: 1,
        pointRadius: 0,
        pointHoverRadius: 0,
      },
    ],
    headers: [
      { title: "Total Rebet CASH balance", amount: 24000, percentage: 7 },
      { title: "Non-wagered Rebet CASH", amount: 3500, percentage: -5 },
      { title: "Redeemable Rebet CASH", amount: 18900, percentage: 10 },
    ],
  };

  return (
    <div className="fraudulent-operations-table-container">
      <PlayersLineChart data={kpis} title="User balance" />

      <Table
        columns={columns}
        dataSource={data}
        pagination={false}
        rowKey={(record) => record.id}
        scroll={{ x: 1200 }}
        onRow={(record) => ({
          onClick: () => {
            console.log(record);
          },
        })}
      />

      <div className="pagination">
        <Pagination
          current={currentPage}
          total={data.length}
          pageSize={pageSize}
          showSizeChanger
          onChange={handlePaginationChange}
        />
      </div>
    </div>
  );
}

export default FraudulentOptionsTable;
